import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { printQuotedmgc3s3pgfors as printQuoted } from './StringOps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonToStringWriterClass;
function JsonToStringWriter() {
  if (JsonToStringWriterClass === VOID) {
    class $ {
      constructor() {
        this.x27_1 = StringBuilder().bc(128);
      }
      b2c(value) {
        this.x27_1.zg(value);
      }
      v2b(char) {
        this.x27_1.xb(char);
      }
      x2b(text) {
        this.x27_1.wb(text);
      }
      h2c(text) {
        printQuoted(this.x27_1, text);
      }
      y27() {
        this.x27_1.ch();
      }
      toString() {
        return this.x27_1.toString();
      }
    }
    initMetadataForClass($, 'JsonToStringWriter', JsonToStringWriter);
    JsonToStringWriterClass = $;
  }
  return JsonToStringWriterClass;
}
//region block: exports
export {
  JsonToStringWriter as JsonToStringWriter25agxcyem0yhk,
};
//endregion

//# sourceMappingURL=JsonToStringWriterJsWasm.mjs.map
